import React from "react";

const Banner = () => {
  return (
    <div className="banner">
      <div className="details">
        <h2>
          <span>The</span> <br />
          <span>Greatest</span> <br />
          <span>Outdoors</span>
        </h2>
        <p>Wishlists curated by Airbnb.</p>
        <button>Get Inspired</button>
      </div>
    </div>
  );
};

export default Banner;
